import React, { useState } from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { useDrawer } from '../../hooks/use-drawer';
import { imgUrl } from '../../utils/consts';
import { GiftCardSelectImage } from './gift-card-select-image';
import { setOverlayEvent, setButtonEvent } from '../../utils/analytics';
import { getImageName } from '../../utils/general';

interface IGCImagePlaceHolderProps {
  image?: string;
  onClick: () => void;
  buttonText?: string | null;
}

interface IGCImageGalleryProps {
  selectedImage?: string;
  onImageChange: (img: string) => void;
}

export const GiftCardImagePlaceholder: React.FC<IGCImagePlaceHolderProps> = ({
  image,
  onClick,
  buttonText
}) => {
  return (
    <div className="sui-w-full sui-flex sui-justify-center">
      <div className="sui-flex sui-flex-col sui-gap-4">
        <img
          className="sui-rounded-md"
          src={image}
          alt="Placeholder img"
          height="180"
          width="320"
          data-testid="add-gift-card-image"
        />
        <div className="sui-self-end">
          <Button variant="ghost" onClick={onClick} data-testid="change-image-button">
            {buttonText || 'Change Image'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export const GiftCardImageGallery: React.FC<IGCImageGalleryProps> = ({
  selectedImage,
  onImageChange
}) => {
  // image is the selected image file name
  const [image, setImage] = useState('');
  const { openDrawer, closeDrawer, updateDrawerState } = useDrawer();

  const handleImageSelect = (value: string) => {
    setImage(value);
    const newDrawerState = {
      saveChangesProps: {
        onClick: () => {
          const imageFile = getImageName(value);
          const settings = `add gift card overlay: change image success: image: ${imageFile}`;
          setButtonEvent(settings);
          onImageChange(value);
          closeDrawer();
        }
      },
      ContentComponent: GiftCardSelectImage,
      componentProps: {
        userSelectedImg: value
      }
    };
    updateDrawerState(newDrawerState);
  };

  const handleOnImageChange = () => {
    setOverlayEvent('add', 'change image');
    openDrawer({
      title: 'Change Image',
      saveChangesProps: {
        buttonText: 'Save Changes'
      },
      cancelProps: {
        onClick: () => {
          closeDrawer();
          setImage('');
        }
      },
      ContentComponent: GiftCardSelectImage,
      componentProps: {
        onImageSelect: handleImageSelect,
        userSelectedImg: image || selectedImage
      }
    });
  };

  return (
    <GiftCardImagePlaceholder
      image={`${imgUrl.host}${imgUrl.pathname}${image || selectedImage}`}
      onClick={handleOnImageChange}
    />
  );
};
